import { defineAsyncComponent } from 'vue';

export * from './constants';

export const retainerMicroFrontends = {
	RetainerPeriodModal: defineAsyncComponent(
		() => import('./components/RetainerPeriodModal')
	),
};
